<template>
  <div>
    <table
      class="table-comment text-center"
    >
      <tr
        class="grey-td"
      >
        <td>倉庫</td>
        <td>時效</td>
        <td
          v-if="!$store.state.userData.uid !=='1000' || !$store.state.userData.settings || $store.state.edition!== 's'"
        >
          集運件
        </td>
        <td>
          <HoverTips>
            <u>商業件?</u>
            <template #content>
              <div
                class="text-left nowrap"
              >
                商業件定義為一批5件以上的子母件貨物<br>
                例如：入庫單號為xxx0001、 xxx0002…xxx0009的包裹
              </div>
            </template>
          </HoverTips>
        </td>
      </tr>
      <tr class="card-bg">
        <td />
        <td />
        <td
          v-if="!$store.state.userData.uid !=='1000' || !$store.state.userData.settings || $store.state.edition!== 's'"
          nowrap
          class="pa-0"
        >
          <template v-if="$store.state.userData.settings && $store.state.edition== 's'">
            不包稅
          </template>
          <v-layout
            v-else
            justify-space-around
            class="mx-0 my-0"
          >
            <div
              class="my-1 feeTypeBtn"
              @click="viewSeFeeType='busi'"
            >
              <v-icon
                v-if="viewSeFeeType==='busi'"
                small
                class="active feeTypeIcon"
              >
                radio_button_checked
              </v-icon>
              <v-icon
                v-else
                small
                class="feeTypeIcon"
              >
                radio_button_unchecked
              </v-icon>
              不包稅
            </div>
            <div
              class="my-1 feeTypeBtn"
              @click="viewSeFeeType='frt'"
            >
              <v-icon
                v-if="viewSeFeeType==='frt'"
                small
                class="active feeTypeIcon"
              >
                radio_button_checked
              </v-icon>
              <v-icon
                v-else
                small
                class="feeTypeIcon"
              >
                radio_button_unchecked
              </v-icon>
              包頻繁稅
            </div>
            <div
              class="my-1 feeTypeBtn"
              @click="viewSeFeeType='tax'"
            >
              <v-icon
                v-if="viewSeFeeType==='tax'"
                small
                class="active feeTypeIcon"
              >
                radio_button_checked
              </v-icon>
              <v-icon
                v-else
                small
                class="feeTypeIcon"
              >
                radio_button_unchecked
              </v-icon>
              全包稅
            </div>
          </v-layout>
        </td>
        <td>不包稅</td>
      </tr>
      <tr
        v-for="(feeItem,i) in feeList"
        :key="feeItem.srid"
        class="card-bg"
      >
        <td nowrap>
          {{ feeItem.label }}
        </td>
        <td nowrap>
          {{ feeItem.timespanMin }}-{{ feeItem.timespanMax }}天
        </td>
        <td
          v-if="!$store.state.userData.uid !=='1000' || !$store.state.userData.settings || $store.state.edition!== 's'"
        >
          <template v-if="viewSeFeeType==='frt'">
            NT$ {{ $calc.add(feeItem.fwFee, feeItem.frtFee) }} / KG
          </template>
          <template v-else-if="viewSeFeeType==='tax'">
            NT$ {{ $calc.add(feeItem.fwFee, feeItem.taxFee) }} / KG
          </template>
          <template v-else>
            NT$ {{ feeItem.fwFee }} / KG
          </template>
        </td>
        <td nowrap>
          NT$ {{ Number(feeItem.fwFee)+Number(feeItem.bizFee) }}/KG
        </td>
      </tr>
    </table>
    <table
      v-if="!inject"
      style="margin-top: -1px;"
      class="table-comment contentTable"
    >
      <template v-if="$store.state.userData.settings && $store.state.edition=== 's'">
        <tr>
          <td>
            <div class="subTitle text-left">
              正式報關
            </div>
          </td>
          <td>
            <div>
              快件專區報關費 210元 一般倉報關費 1800元
            </div>
          </td>
        </tr>
      </template>
      <tr>
        <td>
          <div class="subTitle text-left">
            體積重量
          </div>
        </td>
        <td>
          <div>
            不計拋<br>
            海快體積限制：單件包裹限制長寬高180cm*180cm*長(不限)，三邊長度其中兩邊不得超過180cm (例如：110*90*500 可以，190*120*200 不可以)
            <br>
            海快重量限制：單件不能超過70kg
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="subTitle text-left">
            計重方式
          </div>
        </td>
        <td>
          <div>
            打包前稱重不計包材重量。超出0.1KG內不計重量，超過以0.5KG進位。
          </div>
        </td>
      </tr>
      <tr v-if="isBusySeason">
        <td>
          <div class="subTitle text-left">
            繁盛期
          </div>
        </td>
        <td>
          <div>
            每年11/1~除夕前皆加收繁盛期服務費10元/kg。<br>
            會員等級達到20級可以通過購買久久會員卡免除繁盛期服務費。
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="subTitle text-left">
            承運標準
          </div>
        </td>
        <td>
          <div>
            合包後需超過5KG（不滿5公斤以5公斤計費）
            5KG以下可使用巧拼與他人合包省運費。
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="subTitle text-left">
            丟貨賠償
          </div>
        </td>
        <td>
          按丟失保價金額賠償
        </td>
      </tr>
      <tr>
        <td>
          <div class="subTitle text-left">
            禁運品
          </div>
        </td>
        <td>
          <div>
            食品、農產品、乾燥花、地板、瓷磚、電話卡(網卡)、醫藥用品、酒、毒品、槍支、易燃易爆物、電子煙相關產品...
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import dayjs from 'dayjs'
export default {
  props: {
    inject: Boolean,
  },
  data () {
    return {
      month: dayjs().month(),
    }
  },
  computed: {
    viewSeFeeType: {
      get () {
        return this.$store.state.shippingRate.viewSeFeeType
      },
      set (v) {
        this.$store.commit('shippingRate/setViewSeFeeType', v)
      }
    },
    feeList () {
      const list = this.$store.state.jyShippingRatesSource.filter(item => item.transport === 'se')
      list.sort((a, b) => {
        if (a.addrid === '2769') {
          return -1
        }
        return 0
      })
      return list.filter(whs => {
        if (whs.addrid === '1769' ||
            whs.addrid === '1050' ||
            whs.addrid === '2591' ||
            whs.srLabel === 'HZKZQ' ||
            whs.srLabel === 'HZKHD' ||
            whs.srLabel === 'ONE-YIXIN' ||
            whs.srLabel?.startsWith('BIZECO') ||
            whs.srLabel?.startsWith('TBPDD') ||
            whs.srLabel === 'ENT1688'
        ) {
          return false
        }
        if (whs.addrid === '1579' && this.$store.state.edition !== 's') {
          return false
        }
        if (whs.srLabel === 'AUTOSHIP' && this.$store.state.edition !== 's') {
          return false
        }
        return true
      }).map(whs => {
        const fee = {
          ...whs,
        }
        if (fee.srExtras && fee.srExtras.billboard) {
          Object.assign(fee, fee.srExtras.billboard)
        }

        return fee
      })
    },
    isBusySeason () {
      return this.$store.getters['fee/busySeason/isBusySeason']
    },
  },
}
</script>
<style lang="postcss" scoped>
.grey-td {
  background: #efefef;
}
.dark {
  .grey-td {
    background: #353535;
  }
}
.feeTypeBtn {
  cursor: pointer;
}
.feeTypeIcon {
  font-size: 18px !important;
  margin-bottom: 1px;
  &.active{
    color: #F2B500;
  }
}
.table-comment {
  width: 100%;
  td {
    padding: 10px;
  }
}
.contentTable {
  tr:first-child td {
    border-top: 0;
  }
  td:first-child {
    width: 100px;
    border-right: 0;
  }
  td:nth-child(2){
    border-left: 0;
  }
  .subTitle:before {
    background: #F2B500;
  }
}
</style>
